<template>
  <ui-dialog
    :title='dialogTitle'
    :isVisible.sync='isVisible'
    :isLoading='isLoading'
    customClass='dialog-activity-review'
    @close='close'
  >
    <activity-item
      :data='data'
      :item='item'
      :formModel='formModel'
      :autoSave='mixAutoSave'
      @onStockCard="$emit('onStockCard', $event)"
    >
      <template v-slot:user-actions>
        <button type="button" class="btn btn-size-s btn-mobile-full" @click="$emit('onConnectPO', { rfqid: data.rfqid })">
          {{L10n('open-po')}}
        </button>
        <button type="button" class="btn btn-size-s btn-mobile-full" @click="$emit('onConnectWO', { rfqid: data.rfqid })">
          {{L10n('open-wo')}}
        </button>
      </template>
    </activity-item>
  </ui-dialog>
</template>

<script>
import { routeEditLogic } from '@/mixins/modals'
import { ServiceCustomerPOFollowUp } from '@/services/CustomerPOFollowUp'
import { MainModel } from '@/models/CustomerPOFollowUp'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'DialogActivityItem',
  mixins: [routeEditLogic, AutoSaveMixin],
  components: {
    'activity-item': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityItemCustomerPoFollowUp/Index'),
    'ui-dialog': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/Dialog')
  },
  data () {
    return {
      isLoading: true,
      isVisible: false,
      data: {},
      item: {}
    }
  },
  computed: {
    apiAutoSave () {
      return `CustomerPOFollowUps/Patch/${this.data.id}`
    },
    isAvailableToSave () {
      return true
    },
    dialogTitle () {
      return this.L10n('open-po')
    },
    selectRequest () {
      return [
        'id',
        'po', 'partID', 'partSN', 'reminderDate',
        'orderPhaseID', 'orderPhasePersonInChargeEmployeeID', 'dateInPhase', 'priorityID', 'lastInfo',
        'exchAgreementSigned', 'unitShipped', 'coreReceived', 'repairCostsApproved', 'unitReceivedCustomer',

        'rfq3.id as rfq3ID',
        'rfq3.price as price', 'rfq3.currencyID as currencyID',
        'rfq3.conditionID as conditionID', 'rfq3.quoteDate', 'rfq3.supplyDate', 'rfq3.tagInfoCompanyID',
        'rfq3.tagDate', 'rfq3.traceabilityCompanyID', 'rfq3.remarks', 'rfq3.exchangeCoreValue',
        'rfq3.exchangeCoreValueCurrencyID', 'rfq3.exchangeConditionID',
        'rfq3.exchangeCoreReceived', 'rfq3.coreDueDate', 'rfq3.stockID', 'rfq3.qty as qty',

        'rfq3.rfq.id as rfqID',
        'rfq3.rfq.rfqid as rfqid', 'rfq3.rfq.rfqTypeID as rfqTypeID',
        'rfq3.rfq.requestedDate as requestedDate',
        'rfq3.rfq.customerCompanyID as customerCompanyID',
        'rfq3.rfq.customerContactID as customerContactID'
      ].join(',')
    }
  },
  methods: {
    formModel () {
      return new MainModel()
    },
    loadData (id) {
      this.isLoading = true
      ServiceCustomerPOFollowUp
        .getDynamic(id, {
          select: this.selectRequest
        })
        .then(({ data }) => {
          this.data = data
          this.item = data
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    close () {
      this.mixSetRoute()
      this.$emit('onClose')
    },
    mixHookState ({ value }) {
      this.isVisible = true
      this.loadData(value)
    },
    mixHookReset () {
      this.data = {}
      this.item = {}
    },
    getFormData () {
      return {
        id: this.data.id
      }
    }
  }
}
</script>

<style lang='stylus'>
  .dialog-activity-review{
    width: 100%;
    max-width: 120rem;
    margin-top: 3rem !important;
  }
</style>
